import { INWARD_CODE_LENGTH, OUTWARD_CODE_LENGTH } from "../constants/postcode";

const formatPostcode = (postcode) => {
  if (!postcode) {
    return "";
  }
  const outwardCode = postcode
    .slice(0, postcode.length - INWARD_CODE_LENGTH)
    .padEnd(OUTWARD_CODE_LENGTH, " ");
  const inwardCode = postcode.slice(-INWARD_CODE_LENGTH);

  return `${outwardCode}${inwardCode}`.toUpperCase();
};

export default formatPostcode;
